import axios from "axios";

const API_URL =
  import.meta.env.VITE_DASH_API_URL || "https://dashboard.lono.co.in/api/dashboard";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    // Retrieve the token using the key defined in AuthContext.jsx
    const token = localStorage.getItem("token"); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const dashboardAPI = {
  getActiveApplications: async () => {
    try {
      const response = await api.get("/applications/active");
      return response.data;
    } catch (error) {
      console.error("Error fetching active applications:", error);
      throw error;
    }
  },
  getApprovedApplications: async () => {
    try {
      const response = await api.get("/applications/approved");
      return response.data;
    } catch (error) {
      console.error("Error fetching approved applications:", error);
      throw error;
    }
  },
  getAllStaff: async () => {
    try {
      const response = await api.get("/staff/all");
      return response.data;
    } catch (error) {
      console.error("Error fetching all staff:", error);
      throw error;
    }
  },
  getRecentActivity: async () => {
    try {
      const response = await api.get("/activity/recent");
      return response.data;
    } catch (error) {
      console.error("Error fetching recent activity:", error);
      throw error;
    }
  },
};
